export const PAGE = 'PAGE';
export const MULTI_PAGE = 'MULTI_PAGE';
export const TEMPLATE_TOP_BOTTOM = 'TEMPLATE_TOP_BOTTOM';
